// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/index.vue'; 
import Announcement from '@/views/announcement.vue'; 
import Solution1 from '@/views/solution1.vue'; 
import Solution2 from '@/views/solution2.vue'; 
import Solution3 from '@/views/solution3.vue'; 
import Solution4 from '@/views/solution4.vue'; 
import Solution5 from '@/views/solution5.vue'; 
import Solution6 from '@/views/solution6.vue'; 


Vue.use(Router);
// 防止连续点击多次路由报错
const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history', // 路由模式，可选值：'hash' 或 'history'
  base: process.env.BASE_URL,  // 👈 添加这一行
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/announcement',
      name: 'Announcement',
      component: Announcement,
    },
    {
      path: '/solution1',
      name: 'Solution1',
      component: Solution1,
    },
    {
      path: '/solution2',
      name: 'Solution2',
      component: Solution2,
    },
    {
      path: '/solution3',
      name: 'Solution3',
      component: Solution3,
    },
    {
      path: '/solution4',
      name: 'Solution4',
      component: Solution4,
    },
    {
      path: '/solution5',
      name: 'Solution5',
      component: Solution5,
    },
    {
      path: '/solution6',
      name: 'Solution6',
      component: Solution6,
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有保存的滚动位置（例如浏览器后退），返回保存的位置
      return savedPosition;
    } else {
      // 默认滚动到页面顶部
      return { x: 0, y: 0 };
    }
  },
});